module.exports = __webpack_public_path__ + "media/images/courseware_completion_status_available-37b23a82b4b77d0d878deb90e9f4b8a5.png";